import React, { ChangeEvent, Component } from "react";

import { AudioCodec } from "@formant/core/model/AudioCodec";
import { audioCodecs } from "@formant/core/model/audioCodecs";
import { IDeviceConfigurationDocument } from "@formant/core/model/IDeviceConfigurationDocument";
import { IDeviceTeleopRosStreamConfiguration } from "@formant/core/model/IDeviceTeleopRosStreamConfiguration";

import { SelectField } from "../common/SelectField";
import {
    EditTeleopStreamPopup,
    IEditTeleopStreamPopupProps,
} from "./EditTeleopStreamPopup";

export interface ITeleopAudioConfigurationProps extends IEditTeleopStreamPopupProps {
    streamName?: string;
    document: IDeviceConfigurationDocument;
    onChange: (document: IDeviceConfigurationDocument) => void;
}

export class TeleopAudioConfiguration extends Component<ITeleopAudioConfigurationProps> {
    public render() {
        const { streamName, document, onClose, visible } = this.props;
        const stream = document.teleop?.rosStreams?.find(
            _ => _.topicName === streamName,
        );
        return (
            <EditTeleopStreamPopup
                visible={visible}
                onClose={onClose}
                title={`Configuration for: ${streamName}`}
            >
                <SelectField
                    label="Audio format"
                    value={stream?.audioCodec}
                    onChange={this.onChangeCodec(stream)}
                >
                    {audioCodecs.map(codec => {
                        return (
                            <option key={codec} value={codec}>
                                {codec}
                            </option>
                        );
                    })}
                </SelectField>
            </EditTeleopStreamPopup>
        );
    }
    private onChangeCodec =
        (stream: IDeviceTeleopRosStreamConfiguration | undefined) =>
        (event: ChangeEvent<HTMLSelectElement>) => {
            if (!stream) {
                return;
            }
            const { document, onChange } = this.props;
            stream.audioCodec = event.target.value as AudioCodec;
            onChange({ ...document });
        };
}
